<template>
  <Modal
    :title="$t(`approval.${status}_text`)"
    width="520"
    v-model="visible"
    @on-cancel="onCancel"
  >
    <Form ref="formRef" :model="formData" :rules="rules">
      <FormItem prop="review">
        <Input
          :value="review"
          :maxlength="500"
          show-word-limit
          @on-change="onChange"
          type="textarea"
          :placeholder="$t('approval.review')"
          style="width: 100%"
        />
        <CommonPhrasesModal @onChange="onChangePhrases" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="onCancel">
        {{ $t('btn.cancel') }}
      </Button>
      <Button type="primary" :loading="submitLoading" @click="onOk">
        {{ $t('btn.done') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import CommonPhrasesModal from '@/components/CommonPhrasesModal.vue';

export default {
  props: {
    selectAll: {
      type: Boolean,
      default: false
    },
    isSearchClick: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      default: () => {}
    },
    searchAdvancedParams: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CommonPhrasesModal
  },
  data() {
    this.initFormData = {
      employeeId: this.$store.state.self.id,
      formFlowId: null,
      review: null
    };
    return {
      visible: false,
      submitLoading: false,
      formData: _.cloneDeep(this.initFormData),
      rules: {
        review: {
          required: false,
          message: this.$t('approval.review_text')
        }
      },
      requiredApproveReviewFlag: false,
      review: null,
      formId: null,
      status: null,
      batch: false
    };
  },
  methods: {
    cleanReviewText(text) {
      return text
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/\&nbsp;/g, ' ')
        .replace(/<.*?>/g, '');
    },
    onChangePhrases(phrases) {
      const review = `${this.review || ''}${phrases}`;
      this.formData.review = review;
      this.review = this.cleanReviewText(review);
    },
    onChange(e) {
      const rawValue = e.target.value;
      this.formData.review = rawValue
        .replace(/\r{0,}\n/g, '<br/>')
        .replace(/\s/g, '&nbsp;');
      this.review = this.cleanReviewText(rawValue);
    },
    show(status, batch, value) {
      this.visible = true;
      this.review = null;
      this.status = status;
      this.batch = batch;
      if (batch) {
        // 批量
        this.formData.formIds = value;
        this.rules.review.required = true;
        this.requiredApproveReviewFlag = true;
      } else {
        // 单个
        this.rules.review.required = value.requiredApproveReviewFlag;
        this.requiredApproveReviewFlag = value.requiredApproveReviewFlag;
        this.formId = value.id;
        for (let flow of value.flows) {
          if (
            flow.type === 'APPROVER' &&
            flow.status === 'PENDING' &&
            flow.currentFlag
          ) {
            const find = _.find(flow.formFlowEmployees, (emp) => {
              return (
                emp.status === 'PENDING' &&
                emp.employee.id === this.formData.employeeId
              );
            });
            if (find) {
              this.formData.formFlowId = flow.id;
              break;
            }
          }
        }
      }
    },
    async onOk() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            if (this.batch) {
              if (this.selectAll) {
                await this.allSubmit();
              } else {
                await this.batchSubmit();
              }
            } else {
              await this.singleSubmit();
            }
            this.submitLoading = false;
            this.onCancel();
            this.$emit('on-ok');
          } catch (e) {
            this.submitLoading = false;
          }
        }
      });
    },
    // 单个审批
    async singleSubmit() {
      await this.$http(
        'post',
        `mobile/forms/${this.formId}/${this.status}`,
        this.formData,
        true
      );
      this.$Message.success(this.$t(`approval.${this.status}Success`));
    },
    // 批量审批
    async batchSubmit() {
      delete this.formData.formFlowId;
      const res = await this.$http(
        'post',
        `mobile/forms/specify/${this.status}`,
        this.formData,
        true
      );
      const { submitForms, deleteForms, failForms } = res.data;
      if (submitForms.length || deleteForms.length || failForms.length) {
        this.processingErrorMessage(res.data);
      } else {
        this.initSuccessMessage();
      }
    },
    initSuccessMessage() {
      let message = null;
      if (this.status === 'approve') {
        message = this.$t('approval.batchApproveSuccess', {
          count: this.formData.formIds.length
        });
      } else {
        message = this.$t('approval.batchRejectSuccess', {
          count: this.formData.formIds.length
        });
      }
      this.$Message.success(message);
    },
    // 全部审批
    async allSubmit() {
      const { urlParams, params } = this.initSubmit();
      await this.$http(
        'post',
        `mobile/forms/batch/${this.status}${urlParams}`,
        params,
        true
      );
      this.$Message.success(this.$t(`approval.${this.status}Success`));
    },
    initSubmit() {
      let urlParams = '';
      // 有点击查询时
      if (this.isSearchClick) {
        const newFilters = _.cloneDeep(this.filters);
        // 选择“全部” tab，删除readFlag字段
        if ((this.active + '').toLocaleLowerCase() === 'all') {
          delete newFilters.readFlag;
        }
        delete newFilters.page;
        delete newFilters.size;
        _.forEach(newFilters, (_v, k) => {
          if (_.isNil(newFilters[k])) {
            _.unset(newFilters, k);
          }
        });
        urlParams = this.objToUrl(newFilters);
      }
      return {
        urlParams: urlParams,
        params: {
          approveOrReject: {
            employeeId: this.formData.employeeId,
            review: this.formData.review
          },
          ...this.searchAdvancedParams
        }
      };
    },
    objToUrl(obj) {
      const tempArray = [];
      for (const key in obj) {
        if (key && obj[key] !== null && obj[key] !== '') {
          tempArray.push(`${key}=${obj[key]}`);
        }
      }
      return `?${tempArray.join('&')}`;
    },
    processingErrorMessage(data) {
      const { commitForms, submitForms, deleteForms, failForms } = data;
      let tips = [];
      if (deleteForms.length) {
        //已删除的ID
        tips.push(
          this.$t('approval.hasDeleted').replace('$1', deleteForms.join(','))
        );
      }
      if (submitForms.length) {
        // 已处理的ID
        tips.push(
          this.$t('approval.hasProcessed').replace('$1', submitForms.join(','))
        );
      }
      if (failForms.length) {
        //其它错误的ID
        tips.push(
          this.$t('approval.otherErrorTips').replace('$1', failForms.join(','))
        );
      }
      if (commitForms.length) {
        //已处理的ID
        tips.push(this.$t('approval.haveSuccessOperation'));
      }
      this.$Modal.error({
        title: this.$t('team.tip'),
        content: tips.join('，')
      });
    },
    onCancel() {
      this.visible = false;
      this.formData = _.cloneDeep(this.initFormData);
      this.$refs.formRef.resetFields();
    }
  }
};
</script>
